import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  AMBSLOT_URL,
  WINLOSE_REPORT,
  WINLOSE_REPORT_NEW,
  WINLOSE_REPORT_LOGS,
  WINLOSE_RESULT,
  GAME_REPORT,
  M_POST,
  INVOICE_REPORT,
  GENERATE_EXCEL_INVOICE,
  GENERATE_PDF_INVOICE,
  TRANSACTION_AMBPOKER,
  FECTH_AGENT,
  WINLOSE_REPORT_ELASTIC,
  NEW_TRANSACTION_AMBPOKER,
} from '@/utils/api';

import Vue from 'vue';

import utils from '@/services/utils';

@Module({ name: 'report' })
export default class Report extends VuexModule {
  dataWinLose: any = {};

  dataWinLoseElastic: any = {};

  dataWinLoseLog: any = {};

  dataGame: any = [];

  dataInvoice: any = {};

  dataFile: any = {};

  @Mutation
  mutateWinLose(dataWinLose: any) {
    this.dataWinLose = dataWinLose;
  }

  @Action({ commit: 'mutateWinLose' })
  FetchWinLose(criteria: any) {
    return Vue.axios({
      url: `${BASE_URL}${(criteria.isNewWinlose) ? WINLOSE_REPORT_NEW : WINLOSE_REPORT}`,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Mutation
  mutateWinLoseElastic(data: any) {
    this.dataWinLoseElastic = data;
  }

  @Action({ commit: 'mutateWinLoseElastic' })
  FetchWinLoseElastic(criteria: any) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_ELASTIC,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Mutation
  mutateInvoice(data: any) {
    this.dataInvoice = data;
  }

  @Action({ commit: 'mutateInvoice' })
  FetchInvoice(criteria: object) {
    return Vue.axios({
      url: BASE_URL + INVOICE_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Mutation
  mutateFileExcel(data: any) {
    this.dataFile = data;
  }

  @Action({ commit: 'mutateFileExcel' })
  generateFileExcel(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_EXCEL_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutateFilePdf(data: any) {
    this.dataFile = data;
  }

  @Action({ commit: 'mutateFilePdf' })
  generateFilePdf(dataInvoice: object) {
    return Vue.axios({
      url: BASE_URL + GENERATE_PDF_INVOICE,
      responseType: 'blob',
      data: dataInvoice,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataFile = data;
        return {
          dataFile,
        };
      })
      .catch((err) => err);
  }

  @Mutation
  mutateGameReport(dataGame: any) {
    this.dataGame = dataGame;
  }

  @Action({ commit: 'mutateGameReport' })
  FetchGameReport(criteria: object) {
    return Vue.axios({
      url: BASE_URL + GAME_REPORT,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Mutation
  mutateWinLoseLog(dataWinLoseLog: any) {
    this.dataWinLoseLog = dataWinLoseLog;
  }

  @Action({ commit: 'mutateWinLoseLog' })
  FetchWinLoseLog(criteria: object) {
    return Vue.axios({
      url: BASE_URL + WINLOSE_REPORT_LOGS,
      data: criteria,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          const dataWinLoseLog = data.data;
          return {
            ...dataWinLoseLog,
          };
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchResult(params) {
    return Vue.axios({
      headers: { Authorization: params.isAmbPoker ? '' : `Bearer ${utils.getUserPersistent().token}` },
      url: (params.categories === 'slot' ? AMBSLOT_URL : BASE_URL) + WINLOSE_RESULT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const result = data.data;
          return result;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchTransaction(params) {
    return Vue.axios({
      url: BASE_URL + TRANSACTION_AMBPOKER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const result = data.data;
          return result;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchNewTransaction(params) {
    return Vue.axios({
      url: BASE_URL + NEW_TRANSACTION_AMBPOKER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const dataResult = data;
        return dataResult;
      })
      .catch((err) => err);
  }

  @Action
  FetchAgent(params) {
    return Vue.axios({
      url: BASE_URL + FECTH_AGENT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const result = data.data;
          return result;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
